import { render, staticRenderFns } from "./Geolocalizzazione.vue?vue&type=template&id=02003ce8&scoped=true&"
import script from "./Geolocalizzazione.vue?vue&type=script&lang=js&"
export * from "./Geolocalizzazione.vue?vue&type=script&lang=js&"
import style0 from "./Geolocalizzazione.vue?vue&type=style&index=0&id=02003ce8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02003ce8",
  null
  
)

export default component.exports